import { SidebarMetaInfo } from "@/utils/getSidebarMetaInfo";
import { Button, Group, SimpleGrid, Text, Title } from "@mantine/core";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import Link from "next/link";
import { SocialIcons } from "../../features/Socials";
import css from "./Sidebar.module.css";

dayjs.locale("ru");

export function Sidebar({
  sidebarMetaInfo,
}: {
  sidebarMetaInfo: SidebarMetaInfo | undefined;
}) {
  if (!sidebarMetaInfo) {
    return null;
  }

  return (
    <aside className={css.sidebar}>
      {Object.entries(sidebarMetaInfo.blogs).map(([tag, item]) => (
        <div key={tag}>
          <Link href={`/tag/${tag}`} prefetch={false}>
            <Title order={5} className={css.widgetTitle}>
              #{item.tag.label}
            </Title>
          </Link>

          <div className={css.section}>
            {item.blogs.map((item) => (
              <Link
                key={item.title}
                href={`/blog/${item.slug}`}
                prefetch={false}
              >
                <Text>{item.title}</Text>
                <Text color="#6d6d6d" size="xs">
                  {dayjs(item.created).format("D MMM YYYY")}
                </Text>
              </Link>
            ))}
          </div>
        </div>
      ))}

      {sidebarMetaInfo.popularTags.length > 0 && (
        <div>
          <Title order={5} className={css.widgetTitle}>
            Популярные теги
          </Title>

          <SimpleGrid cols={3}>
            {sidebarMetaInfo.popularTags.map((tag) => (
              <Link
                href={`/tag/${tag.value}`}
                key={tag.value}
                className={css.link}
                prefetch={false}
              >
                <Button
                  fw="normal"
                  variant="subtle"
                  style={{ color: tag.color ?? "gray" }}
                  px={0}
                >
                  #{tag.label.toLowerCase()}
                </Button>
              </Link>
            ))}
          </SimpleGrid>
        </div>
      )}

      <div>
        <Title order={5} className={css.widgetTitle}>
          Подпишись
        </Title>
        <Group>
          <SocialIcons variant="large" />
        </Group>
      </div>
    </aside>
  );
}
